import { ISearchMakerProductsRequest } from "@faire/web-api/indigofair/data/ISearchMakerProductsRequest";
import {
  QueryParameters,
  path as productPage,
} from "@faire/web-api/routes/product/productToken";
import { FAIRE_DIRECT_BRAND_QUERY_PARAM } from "@faire/web/common/routes/faire-direct/FAIRE_DIRECT_BRAND_QUERY_PARAM";
import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import qs from "query-string";

export namespace ProductPagePaths {
  export function index(
    productToken: string,
    queries: index.IQueries = {}
  ): string {
    if (isPrerender()) {
      // For SEO discoverability, we want to render product tile urls without any
      // query parameters so that google bot can see the canonical path to product page
      return productPage(productToken);
    }

    return productPage(productToken, queries as QueryParameters);
  }

  export namespace index {
    export interface IQueries {
      refB?: string;
      refC?: string;
      refS?: string;
      refF?: string[];
      refOrigin?: string;
      /** referrer filters read from the search path */
      brandToken?: string;
      productOptionToken?: string;
      /** select a product option in the variant picker by cart item or product option token */
      findByToken?: string;

      /** e-mail token where it's referenced from */
      oet?: string;
      /** source token suitable to be appended to event track path in order to log the link source */
      trackEventToken?: string;

      // queries impacting product sort to pass back to the brand page
      // see brandPage#IQueryObj
      /** brand cat passed from brand page */
      bCat?: string;
      /** brand sortBy passed from brand page */
      bSortBy?: keyof typeof ISearchMakerProductsRequest.SortBy;
      /** brand q passed from brand page */
      bQ?: string;
      /** brand sortingHint passed from brand page */
      bSortingHint?: boolean;
      /** brand page passed from brand page */
      bPage?: number;

      /** brand refS passed from brand page */
      bRefS?: string;
      /** brand refC passed from brand page */
      bRefC?: string;
      /** brand refF passed from brand page */
      bRefF?: string[];
      /** brand refP passed from brand page */
      bRefP?: string[];

      /**update cart from mobile page */
      updateQuantityOnChange?: boolean;

      /**
       * brand filters keys passed directly to ISearchMakerProductsRequest.filterKeys, when fetching.
       */
      bFilters?: string[];

      impressionId?: string;

      /** Faire Direct query param for when the portal is active. */
      [FAIRE_DIRECT_BRAND_QUERY_PARAM]?: string;
    }

    // FIXME: This isn't needed. Put params on backend definition, use QueryParameters.parse
    export const parseSearch = (locationSearch: string): IQueries =>
      qs.parse(locationSearch);
  }
}
